import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
/**
 * Initialize Complete Request Schema
 * POST /api/v2/initialize/complete
 *
 * Marks the initial-setup wizard as finished. Requires departments and
 * users to be initialized first (the structural anchor); the optional
 * steps (org-functions, systems, processes) may be skipped.
 */ export const InitializeCompleteRequestSchema = z.object({});
/**
 * Initialize Complete Response Schema
 * Idempotent: a second call returns the originally stored timestamp.
 */ export const InitializeCompleteResponseSchema = z.object({
    completedAt: z.number()
});
export const InitializeCompleteErrorSchema = BaseErrorSchema;

//# sourceMappingURL=initialize-complete.schema.js.map